import { Injectable } from '@angular/core';
import { VexLayoutService } from '@vex/services/vex-layout.service';
import { NavigationItem } from './navigation-item.interface';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NavigationLoaderService {
  private readonly _items: BehaviorSubject<NavigationItem[]> =
    new BehaviorSubject<NavigationItem[]>([]);

  get items$(): Observable<NavigationItem[]> {
    return this._items.asObservable();
  }

  constructor(private readonly layoutService: VexLayoutService) {
    this.loadNavigation();
  }

  loadNavigation(): void {
    this._items.next([
      {
        type: 'subheading',
        label: 'Inicio',
        children: [
          // [HIDDEN] Mis predios — oculto temporalmente
          // {
          //   type: 'link',
          //   label: 'Mis predios',
          //   route: '/home/mis-predios',
          //   icon: 'mat:location_on'
          // },
          {
            type: 'link',
            label: 'Mis procesos',
            route: '/home/mis-procesos',
            icon: 'mat:question_answer'
          },
          // [HIDDEN] Mis trámites — oculto temporalmente
          // {
          //   type: 'link',
          //   label: 'Mis trámites',
          //   route: '/home/mis-tramites',
          //   icon: 'mat:assignment_turned_in'
          // }
        ]
      },
      {
        type: 'subheading',
        label: 'Gestión',
        children: [
          {
            type: 'link',
            label: 'Consultar proceso',
            route: '/gestion/consultar',
            icon: 'mat:find_in_page'
          },
          {
            type: 'link',
            label: 'Nuevo proceso',
            route: '/gestion/generar',
            icon: 'mat:note_add'
          },
        ]
      },
      {
        type: 'subheading',
        label: 'Mesa de ayuda',
        children: [
          {
            type: 'link',
            label: 'Consultar solicitud',
            route: '/mesa-de-ayuda/consultar',
            icon: 'mat:find_in_page'
          },
          {
            type: 'link',
            label: 'Nueva solicitud',
            route: '/mesa-de-ayuda/generar',
            icon: 'mat:note_add'
          },
        ]
      },
    ]);
  }
}
